import React, { useEffect, useState } from "react";
import SelectOption from "./SelectOption";
import { useTranslation } from "../contexts/LocaleContext";

// Files related modals
export const AddFileModal = ({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [subjectlocating, setSubjectlocating] = useState(
    initialData?.subjectlocating || ""
  );
  const [subject, setSubject] = useState(initialData?.subject || "");
  const [content, setContent] = useState(initialData?.content || "");
  const [status, setStatus] = useState(initialData?.status ?? "1");
  const [filename, setFilename] = useState(initialData?.filename || "");
  const [locating, setLocating] = useState(initialData?.locating || "");

  useEffect(() => {
    if (initialData) {
      setSubjectlocating(initialData.subjectlocating || "");
      setSubject(initialData.subject || "");
      setContent(initialData.content || "");
      setStatus(initialData.status ?? "1");
      setFilename(initialData.filename || "");
      setLocating(initialData.locating || "");
    } else {
      setSubjectlocating("");
      setSubject("");
      setContent("");
      setStatus("1");
      setFilename("");
      setLocating("");
    }
  }, [initialData, isOpen]);
  const [showPreview, setShowPreview] = useState(false);

  const togglePreview = () => setShowPreview((s) => !s);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            {initialData
              ? t
                ? t("file.modal.edit")
                : "Edit file"
              : t
              ? t("file.modal.add")
              : "Add file"}
          </h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <form
          className="modal-body"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({
              id: initialData?.id,
              subject,
              content,
              status,
              filename,
              locating,
              subjectlocating,
            });
          }}
        >
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                    stroke="#6b7280"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 2v6h6"
                    stroke="#6b7280"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {t
                ? t("file.modal.filename_label") || "File's Name"
                : "File's Name"}
            </label>
            <input
              value={filename}
              onChange={(e) => setFilename(e.target.value)}
            />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M4 6h16M4 12h8"
                    stroke="#6b7280"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {t
                ? t("file.modal.title_label") || "File's Title"
                : "File's Title"}
            </label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <span className="label-icon" aria-hidden="true">
                  <svg
                    t="1767855535698"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="42640"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M874.666667 426.666667h-725.333334a64 64 0 0 0-64 64v469.333333a64 64 0 0 0 64 64h725.333334a64 64 0 0 0 64-64v-469.333333a64 64 0 0 0-64-64z m-21.333334 85.333333v426.666667h-682.666666v-426.666667h682.666666z"
                      fill="#000000"
                      p-id="42641"
                    ></path>
                    <path
                      d="M512 0a256 256 0 0 0-256 256v256h512v-256a256 256 0 0 0-256-256z m8.533333 85.546667A170.666667 170.666667 0 0 1 682.666667 256v170.666667h-341.333334v-170.666667a170.666667 170.666667 0 0 1 170.666667-170.666667l8.533333 0.213334z"
                      fill="#000000"
                      p-id="42642"
                    ></path>
                    <path
                      d="M469.333333 597.333333m42.666667 0l0 0q42.666667 0 42.666667 42.666667l0 170.666667q0 42.666667-42.666667 42.666666l0 0q-42.666667 0-42.666667-42.666666l0-170.666667q0-42.666667 42.666667-42.666667Z"
                      fill="#000000"
                      p-id="42643"
                    ></path>
                  </svg>
                </span>
              </span>
              {t ? t("files.table.file_key") : "File's Key"}
            </label>
            <input
              value={subjectlocating}
              onChange={(e) => setSubjectlocating(e.target.value)}
            />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767858311998"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="68990"
                  width="200"
                  height="200"
                >
                  <path
                    d="M675 135c-116.897 0-212 95.103-212 212 0 46.416 15.006 89.387 40.404 124.341L188.373 786.373c-12.497 12.496-12.497 32.758 0 45.254C194.621 837.876 202.811 841 211 841s16.379-3.124 22.627-9.373l89.631-89.631 107.707 107.706c6.249 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.373c12.497-12.496 12.497-32.758 0-45.255L368.514 696.74 410.255 655l74.708 74.708c6.249 6.249 14.438 9.373 22.627 9.373s16.379-3.124 22.627-9.373c12.497-12.496 12.497-32.758 0-45.254l-74.708-74.709 92.837-92.837C583.708 543.335 627.559 559 675 559c116.897 0 212-95.103 212-212s-95.103-212-212-212z m0 360c-39.781 0-75.942-15.781-102.564-41.406a32.26 32.26 0 0 0-2.81-3.222 32.28 32.28 0 0 0-2.809-2.49C542.132 421.428 527 385.951 527 347c0-81.607 66.393-148 148-148s148 66.393 148 148-66.393 148-148 148z"
                    fill="#000000"
                    p-id="68991"
                  ></path>
                </svg>
              </span>
              {t ? t("files.table.key") : "Key"}
            </label>
            <input
              value={locating}
              onChange={(e) => setLocating(e.target.value)}
            />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855715723"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="51363"
                  width="200"
                  height="200"
                >
                  <path
                    d="M556.195 809.433c16.058-2.857 31.109-5.643 45.606-10.422 84.613-27.895 144.845-83.138 182.884-163.31 3.17-6.679 1.161-8.446-5.17-10.18-17.52-4.798-34.898-10.146-52.248-15.544-16.339-5.084-20.286-20.612-7.877-32.418A54797.681 54797.681 0 0 1 897.36 408.986c12.211-11.513 28.276-6.47 32.07 9.968 18.325 79.42 36.537 158.866 54.536 238.362 4.002 17.673-7.473 27.63-24.941 22.316-16.45-5.007-33.075-9.544-49.224-15.39-7.845-2.841-10.34-0.622-13.341 6.377-43.504 101.517-115.47 175.43-215.952 221.438-12.984 5.946-26.299 11.085-39.945 15.335-2.253 0.701-4.133 2.72-6.441-0.922-19.061-30.076-44.465-55.113-66.362-82.951-3.583-4.557-7.354-8.967-11.566-14.086zM802.005 445.003c-6.135-23.324-13.71-44.906-24.475-65.279-37.11-70.244-93.668-117.666-168.27-144.21-7.006-2.493-9.786-1.47-11.82 5.99-4.946 18.147-10.748 36.06-16.408 54.005-5.688 18.02-22.268 21.913-35.025 8.002-54.324-59.253-108.543-118.6-162.703-178.005-12.807-14.046-7.824-29.073 10.788-33.13 77.415-16.868 154.84-33.691 232.263-50.516a93.03 93.03 0 0 1 6.717-1.218c13.445-1.913 23.455 9.359 19.483 22.385-5.109 16.755-10.385 33.47-16.22 49.98-2.324 6.583-1.68 8.967 5.626 11.474 116.98 40.143 200.529 116.948 251.136 229.82 3.554 7.925 3.022 11.555-5.501 14.567-7.319 2.587-13.436 7.77-19.124 13.224-19.5 18.698-39.07 37.323-58.636 55.953-2.26 2.155-4.666 4.156-7.83 6.958zM430.321 232.818c-31.57 10.377-60.088 24.128-86.05 42.92-45.292 32.784-79.09 74.732-101.307 126.111-2.765 6.397-1.518 7.893 4.946 9.213 16.527 3.375 32.889 7.566 49.296 11.524 16.287 3.926 21.463 19.81 9.955 32.004C251.105 514 194.906 573.276 138.606 632.456c-11.96 12.572-28.126 8.372-32.835-8.506-22.056-79.06-43.946-158.169-65.783-237.29-3.753-13.606 7.024-25.029 20.765-21.956 19.321 4.32 38.626 8.774 57.753 13.867 6.795 1.81 9.419 0.276 11.899-6.254 39.176-103.163 108.881-178.564 207.491-227.683 6.3-3.14 9.537-2.36 14.27 2.91 25.406 28.316 51.356 56.147 78.155 85.274zM227.253 586.871c23.597 88.533 76.274 152.741 156.751 194.73 7.277 3.795 9.62 1.932 12.083-5.07 5.484-15.592 11.626-30.962 17.786-46.308 6.29-15.682 21.268-18.283 31.9-5.453 51.691 62.372 103.33 124.793 154.846 187.31 12.733 15.45 7.023 28.972-13.035 32.217-78.918 12.764-157.824 25.609-236.735 38.409-2.246 0.364-4.52 0.61-6.787 0.781-15.587 1.173-24.756-10.425-19.3-25.126a1556.39 1556.39 0 0 1 22.102-56.115c2.394-5.754 1.475-7.958-4.292-10.658-95.606-44.726-163.829-116.25-207.185-212.137-3.041-6.723-2.543-9.148 4.89-10.705 8.188-1.712 14.307-7.403 19.985-13.34 19.792-20.701 39.56-41.433 59.408-62.083 2.185-2.272 3.788-5.318 7.583-6.452z"
                    p-id="51364"
                    fill="#000000"
                  ></path>
                </svg>{" "}
              </span>
              {t ? t("file.modal.status_label") || "Status" : "Status"}
            </label>
            <SelectOption
              value={status}
              onChange={(v) => setStatus(v)}
              options={[
                { value: "1", label: t ? t("status.on") : "ON" },
                { value: "0", label: t ? t("status.off") : "OFF" },
              ]}
              ariaLabel="文件状态"
            />
          </div>

          <div className="form-row full-width">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <rect
                    x="3"
                    y="4"
                    width="18"
                    height="16"
                    rx="2"
                    stroke="#6b7280"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 8h10"
                    stroke="#6b7280"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {t ? t("files.table.content") : "Content"}
            </label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={4}
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-check"
              onClick={togglePreview}
              disabled={isLoading}
            >
              {t ? t("file.modal.preview") : "Preview"}
            </button>
            <button
              type="button"
              className="btn-ghost"
              onClick={onClose}
              disabled={isLoading}
            >
              {t ? t("user.modal.cancel") : "Cancel"}
            </button>
            <button type="submit" className="btn-primary" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="btn-spinner" aria-hidden="true" />
                  {t ? t("user.modal.save") : "Saving..."}
                </>
              ) : initialData ? (
                t ? (
                  t("user.modal.save")
                ) : (
                  "Save"
                )
              ) : t ? (
                t("user.modal.add")
              ) : (
                "Add"
              )}
            </button>
          </div>

          {showPreview && (
            <div
              className="inline-preview preview-body"
              role="region"
              aria-label="Preview"
            >
              <div
                className="preview-content"
                dangerouslySetInnerHTML={{ __html: content || "" }}
              />
            </div>
          )}
        </form>{" "}
      </div>
    </div>
  );
};

// Proxy related modals
export const AddOptionsModal = ({ isOpen, onClose, onAddOne, onAddBulk }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{t ? t("proxy.modal.add") : "Add proxies"}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div
          className="modal-body add-options-list"
          style={{ backgroundColor: "transparent" }}
        >
          <button
            type="button"
            className="option-card"
            onClick={() => {
              onAddOne();
              onClose();
            }}
          >
            <div className="option-left">
              <div className="option-icon">
                <img alt="" src="/main/one.png" />
              </div>
            </div>
            <div className="option-right">
              <div className="option-title">
                {t ? t("proxy.add_one") || "Add one proxy" : "Add one proxy"}
              </div>
              <div className="option-desc">
                {t
                  ? t("proxy.add_one_desc") || "Add a single proxy entry"
                  : "Add a single proxy entry"}
              </div>
            </div>
          </button>
          <button
            type="button"
            className="option-card"
            onClick={() => {
              onAddBulk();
              onClose();
            }}
          >
            <div className="option-left">
              <div className="option-icon">
                <img alt="" src="/main/many.png" />
              </div>
            </div>
            <div className="option-right">
              <div className="option-title">
                {t ? t("proxy.add") : "Add proxies"}
              </div>
              <div className="option-desc">
                {t
                  ? t("proxy.add_many_desc") ||
                    "Add multiple proxies by pasting lines"
                  : "Add multiple proxies by pasting lines"}
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export const BulkAddModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
  const [text, setText] = useState("");
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            {t
              ? t("proxy.bulk.title") || "Batch add proxies"
              : "Batch add proxies"}
          </h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <form
          className="modal-body single-column"
          onSubmit={(e) => {
            e.preventDefault();
            const lines = String(text)
              .split("\n")
              .map((l) => l.trim())
              .filter((l) => l.length > 0);
            onSubmit(lines);
          }}
        >
          <label style={{ marginBottom: 8 }}>
            {t
              ? t(
                  "proxy.bulk.format_hint",
                  "(host,port,account,password,SOCKS5)"
                )
              : "(host,port,account,password,SOCKS5)"}
          </label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={8}
          />
          <div className="modal-actions">
            <button
              type="button"
              className="btn-ghost"
              onClick={onClose}
              disabled={isSubmitting}
            >
              {t ? t("user.modal.cancel") : "Cancel"}
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="btn-spinner" aria-hidden="true" />
                  {t ? t("emails.adding") || "Adding..." : "Adding..."}
                </>
              ) : t ? (
                t("emails.add")
              ) : (
                "Add"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const AddProxyModal = ({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [host, setHost] = useState(initialData?.proxyHost || "");
  const [port, setPort] = useState(initialData?.proxyPort || "");
  const [username, setUsername] = useState(initialData?.proxyUsername || "");
  const [password, setPassword] = useState(initialData?.proxyPassword || "");
  const [type, setType] = useState(initialData?.proxyType || "SOCKS5");
  const [status, setStatus] = useState(initialData?.status ?? "0");

  useEffect(() => {
    if (initialData) {
      setHost(initialData.proxyHost || "");
      setPort(initialData.proxyPort || "");
      setUsername(initialData.proxyUsername || "");
      setPassword(initialData.proxyPassword || "");
      setType(initialData.proxyType || "SOCKS5");
      setStatus(initialData.status ?? "0");
    } else {
      setHost("");
      setPort("");
      setUsername("");
      setPassword("");
      setType("SOCKS5");
      setStatus("1");
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;
  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            {initialData
              ? t
                ? t("proxy.modal.edit")
                : "Edit proxy"
              : t
              ? t("proxy.modal.add")
              : "Add proxy"}
          </h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <form
          className="modal-body"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({
              id: initialData?.id,
              proxyHost: host,
              proxyPort: port,
              proxyUsername: username,
              proxyPassword: password,
              proxyType: type,
              status,
            });
          }}
        >
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767857948440"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="64089"
                  width="200"
                  height="200"
                >
                  <path
                    d="M745.408 896.741H233.859c-0.734 0-1.468-0.04-2.196-0.121-79.325-8.765-139.143-75.625-139.143-155.523 0-86.291 70.203-156.494 156.494-156.494 2.158 0 4.084 0.031 5.836 0.083-0.494-11.149-0.838-22.231-0.838-35.327 0-113.998 92.743-206.742 206.741-206.742 51.301 0 100.501 18.925 138.537 53.288 31.182 28.171 52.838 64.815 62.499 105.105 21.104-7.244 43.194-10.903 65.951-10.903 112.343 0 203.74 91.399 203.74 203.743 0 51.003-18.939 99.808-53.33 137.425-34.162 37.368-80.63 60.586-130.843 65.376-0.63 0.06-1.265 0.09-1.899 0.09z m-510.404-40H744.43c83.897-8.471 147.051-78.336 147.051-162.892 0-90.288-73.453-163.743-163.74-163.743-25.443 0-49.83 5.682-72.481 16.886a20.003 20.003 0 0 1-28.751-15.779c-9.156-84.715-80.415-148.598-165.755-148.598-91.941 0-166.741 74.8-166.741 166.742 0 18.423 0.699 32.259 1.585 49.776l0.278 5.516a20.001 20.001 0 0 1-19.975 20.999c-6.271 0-10.589-0.297-14.397-0.56-3.643-0.25-7.084-0.487-12.488-0.487-64.235 0-116.494 52.259-116.494 116.494-0.002 59.125 43.978 108.655 102.482 115.646z"
                    p-id="64090"
                    fill="#000000"
                  ></path>
                  <path
                    d="M875.14 528.24c-11.046 0-20-8.954-20-20V197.259c0-16.542-13.458-30-30-30H524.161c-16.542 0-30 13.458-30 30v99.991c0 11.046-8.954 20-20 20s-20-8.954-20-20v-99.991c0-38.598 31.401-70 70-70H825.14c38.598 0 70 31.402 70 70V508.24c0 11.046-8.954 20-20 20z"
                    p-id="64091"
                    fill="#000000"
                  ></path>
                  <path
                    d="M870.64 316.752H474.66c-11.045 0-20-8.954-20-20s8.955-20 20-20h395.98c11.046 0 20 8.954 20 20s-8.954 20-20 20zM828.643 383.248h-74.997c-11.046 0-20-8.954-20-20s8.954-20 20-20h74.997c11.046 0 20 8.954 20 20s-8.955 20-20 20zM828.643 251.248h-74.997c-11.046 0-20-8.954-20-20s8.954-20 20-20h74.997c11.046 0 20 8.954 20 20s-8.955 20-20 20zM856.14 452.248H688.148c-11.046 0-20-8.954-20-20s8.954-20 20-20H856.14c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
                    p-id="64092"
                    fill="#000000"
                  ></path>
                </svg>
              </span>
              {t ? t("proxy.table.host") : "Host"}
            </label>
            <input value={host} onChange={(e) => setHost(e.target.value)} />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767858006710"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="66067"
                  width="200"
                  height="200"
                >
                  <path
                    d="M832 106.666667H192C145.066667 106.666667 106.666667 145.066667 106.666667 192v640c0 46.933333 38.4 85.333333 85.333333 85.333333h640c46.933333 0 85.333333-38.4 85.333333-85.333333V192c0-46.933333-38.4-85.333333-85.333333-85.333333zM277.333333 778.666667c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32v-106.666667c0-17.066667 14.933333-32 32-32s32 14.933333 32 32v106.666667z m128 0c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32v-106.666667c0-17.066667 14.933333-32 32-32s32 14.933333 32 32v106.666667z m128 0c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32v-106.666667c0-17.066667 14.933333-32 32-32s32 14.933333 32 32v106.666667z m128 0c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32v-106.666667c0-17.066667 14.933333-32 32-32s32 14.933333 32 32v106.666667z m128 0c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32v-106.666667c0-17.066667 14.933333-32 32-32s32 14.933333 32 32v106.666667zM810.666667 426.666667c0 23.466667-19.2 42.666667-42.666667 42.666666h-85.333333c-23.466667 0-42.666667-19.2-42.666667-42.666666v-42.666667c0-23.466667-19.2-42.666667-42.666667-42.666667h-170.666666c-23.466667 0-42.666667 19.2-42.666667 42.666667v42.666667c0 23.466667-19.2 42.666667-42.666667 42.666666h-85.333333c-23.466667 0-42.666667-19.2-42.666667-42.666666v-170.666667c0-23.466667 19.2-42.666667 42.666667-42.666667h512c23.466667 0 42.666667 19.2 42.666667 42.666667v170.666667z"
                    p-id="66068"
                    fill="#000000"
                  ></path>
                </svg>
              </span>
              {t ? t("proxy.table.port") : "Port"}
            </label>
            <input value={port} onChange={(e) => setPort(e.target.value)} />
          </div>
          {/* type is fixed to SOCKS5 for this UI */}
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855381740"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="40242"
                  width="200"
                  height="200"
                >
                  <path
                    d="M672 320a160 160 0 1 0-160 160 160 160 0 0 0 160-160z m64 0A224 224 0 1 1 512 96a224 224 0 0 1 224 224z"
                    p-id="40243"
                    fill="#000000"
                  ></path>
                  <path
                    d="M224 832a32 32 0 0 1-64 0 352 352 0 0 1 704 0 32 32 0 0 1-64 0 288 288 0 0 0-576 0z"
                    p-id="40244"
                    fill="#000000"
                  ></path>
                </svg>
              </span>
              {t ? t("proxy.table.account") : "Account"}
            </label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855239372"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="37218"
                  width="200"
                  height="200"
                >
                  <path
                    d="M418.133333 499.2c-21.333333-34.133333-29.866667-72.533333-29.866666-115.2 0-119.466667 93.866667-213.333333 213.333333-213.333333s213.333333 93.866667 213.333333 213.333333-93.866667 213.333333-213.333333 213.333333c-46.933333 0-85.333333-12.8-123.733333-38.4l-98.133334 98.133334 46.933334 46.933333-59.733334 59.733333-46.933333-46.933333-29.866667 29.866667 46.933334 46.933333L277.333333 853.333333 170.666667 746.666667l247.466666-247.466667zM601.6 256c-72.533333 0-128 55.466667-128 128s55.466667 128 128 128 128-55.466667 128-128-59.733333-128-128-128z"
                    fill="#000000"
                    p-id="37219"
                  ></path>
                </svg>
              </span>
              {t ? t("proxy.table.password") : "Password"}
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855715723"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="51363"
                  width="200"
                  height="200"
                >
                  <path
                    d="M556.195 809.433c16.058-2.857 31.109-5.643 45.606-10.422 84.613-27.895 144.845-83.138 182.884-163.31 3.17-6.679 1.161-8.446-5.17-10.18-17.52-4.798-34.898-10.146-52.248-15.544-16.339-5.084-20.286-20.612-7.877-32.418A54797.681 54797.681 0 0 1 897.36 408.986c12.211-11.513 28.276-6.47 32.07 9.968 18.325 79.42 36.537 158.866 54.536 238.362 4.002 17.673-7.473 27.63-24.941 22.316-16.45-5.007-33.075-9.544-49.224-15.39-7.845-2.841-10.34-0.622-13.341 6.377-43.504 101.517-115.47 175.43-215.952 221.438-12.984 5.946-26.299 11.085-39.945 15.335-2.253 0.701-4.133 2.72-6.441-0.922-19.061-30.076-44.465-55.113-66.362-82.951-3.583-4.557-7.354-8.967-11.566-14.086zM802.005 445.003c-6.135-23.324-13.71-44.906-24.475-65.279-37.11-70.244-93.668-117.666-168.27-144.21-7.006-2.493-9.786-1.47-11.82 5.99-4.946 18.147-10.748 36.06-16.408 54.005-5.688 18.02-22.268 21.913-35.025 8.002-54.324-59.253-108.543-118.6-162.703-178.005-12.807-14.046-7.824-29.073 10.788-33.13 77.415-16.868 154.84-33.691 232.263-50.516a93.03 93.03 0 0 1 6.717-1.218c13.445-1.913 23.455 9.359 19.483 22.385-5.109 16.755-10.385 33.47-16.22 49.98-2.324 6.583-1.68 8.967 5.626 11.474 116.98 40.143 200.529 116.948 251.136 229.82 3.554 7.925 3.022 11.555-5.501 14.567-7.319 2.587-13.436 7.77-19.124 13.224-19.5 18.698-39.07 37.323-58.636 55.953-2.26 2.155-4.666 4.156-7.83 6.958zM430.321 232.818c-31.57 10.377-60.088 24.128-86.05 42.92-45.292 32.784-79.09 74.732-101.307 126.111-2.765 6.397-1.518 7.893 4.946 9.213 16.527 3.375 32.889 7.566 49.296 11.524 16.287 3.926 21.463 19.81 9.955 32.004C251.105 514 194.906 573.276 138.606 632.456c-11.96 12.572-28.126 8.372-32.835-8.506-22.056-79.06-43.946-158.169-65.783-237.29-3.753-13.606 7.024-25.029 20.765-21.956 19.321 4.32 38.626 8.774 57.753 13.867 6.795 1.81 9.419 0.276 11.899-6.254 39.176-103.163 108.881-178.564 207.491-227.683 6.3-3.14 9.537-2.36 14.27 2.91 25.406 28.316 51.356 56.147 78.155 85.274zM227.253 586.871c23.597 88.533 76.274 152.741 156.751 194.73 7.277 3.795 9.62 1.932 12.083-5.07 5.484-15.592 11.626-30.962 17.786-46.308 6.29-15.682 21.268-18.283 31.9-5.453 51.691 62.372 103.33 124.793 154.846 187.31 12.733 15.45 7.023 28.972-13.035 32.217-78.918 12.764-157.824 25.609-236.735 38.409-2.246 0.364-4.52 0.61-6.787 0.781-15.587 1.173-24.756-10.425-19.3-25.126a1556.39 1556.39 0 0 1 22.102-56.115c2.394-5.754 1.475-7.958-4.292-10.658-95.606-44.726-163.829-116.25-207.185-212.137-3.041-6.723-2.543-9.148 4.89-10.705 8.188-1.712 14.307-7.403 19.985-13.34 19.792-20.701 39.56-41.433 59.408-62.083 2.185-2.272 3.788-5.318 7.583-6.452z"
                    p-id="51364"
                    fill="#000000"
                  ></path>
                </svg>{" "}
              </span>
              {t ? t("file.modal.status_label") || "Status" : "Status"}
            </label>
            <SelectOption
              value={status}
              onChange={(v) => setStatus(v)}
              options={[
                { value: "1", label: t ? t("status.on") : "ON" },
                { value: "0", label: t ? t("status.off") : "OFF" },
              ]}
              ariaLabel="状态"
            />
          </div>
          <input type="hidden" value={type} />
          <div className="modal-actions">
            <button
              type="button"
              className="btn-ghost"
              onClick={onClose}
              disabled={isLoading}
            >
              {t ? t("user.modal.cancel") : "Cancel"}
            </button>
            <button type="submit" className="btn-primary" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="btn-spinner" aria-hidden="true" />
                  {t ? t("user.modal.save") : "Saving..."}
                </>
              ) : initialData ? (
                t ? (
                  t("user.modal.save")
                ) : (
                  "Save"
                )
              ) : t ? (
                t("proxy.modal.add")
              ) : (
                "Add"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
